import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { type OfferV11 } from '@redteclab/api/clients/bully'

import { useGlobalConfigContext } from '../../../../../global-config'
import { productAccessorGetSellerPromotionFromOffer } from '../../../../model/productAccessor/productAccessorGetSellerPromotionFromOffer'
import { productAccessorOfferHasFreeItemSellerPromotion } from '../../../../model/productAccessor/productAccessorOfferHasFreeItemSellerPromotion'

type ProductOfferCardSellerPromotionLabelProps = {
  offer: OfferV11
}

export const ProductOfferCardSellerPromotionLabel: FC<
  ProductOfferCardSellerPromotionLabelProps
> = ({ offer }) => {
  const sellerPromotion = productAccessorGetSellerPromotionFromOffer(offer)
  const { superScripts } = useGlobalConfigContext()

  if (!sellerPromotion) {
    return null
  }

  return (
    <button
      className="flex items-center rounded-full bg-light-brand-medium px-2.5 py-1 text-xs"
      data-qa-id="product-label-seller-promotion"
      type="button"
    >
      {productAccessorOfferHasFreeItemSellerPromotion(offer) ? (
        <FormattedMessage
          id="seller.promotion.product.badge.freeItems"
          values={{
            payableItemCount:
              sellerPromotion.conditionValue - sellerPromotion.discountValue,
            sup: superScripts.sellerPromotions ? (
              <sup>{superScripts.sellerPromotions}</sup>
            ) : null,
            targetItemCount: sellerPromotion.conditionValue,
          }}
        />
      ) : (
        <FormattedMessage id="seller.promotion.product.badge" />
      )}
    </button>
  )
}
